import { writable } from 'svelte/store';

export const limitationRecherche = writable(0);
